import {
  AgentExecution,
  Entities,
} from '~/features/ask-anything/agentic-ai/types';
import { sylvanus } from '~/services/serviceInstances';
import { Entity } from '~/types/Entity';

import {
  AgentType,
  NewAgentExecutionApiV1AgentExecutionPostApiResponse,
} from '../../types/sylvanus/agentExecution';
import { mapServerAgentExecutionToAgentExecution } from './transformers';

type Request = {
  agentType: AgentType;
  agentConfiguration?: {
    externalEntities?: Entity<Entities>[];
    metadata?: Record<string, any>;
  };
  executionTag?: string;
};

export const createAgentExecution = async (
  request: Request,
): Promise<AgentExecution> => {
  const response =
    await sylvanus.post<NewAgentExecutionApiV1AgentExecutionPostApiResponse>(
      '/agent-execution',
      {
        agent_type: request.agentType,
        agent_configuration: {
          external_entities: request.agentConfiguration?.externalEntities,
          metadata: request.agentConfiguration?.metadata,
        },
        execution_tag: request.executionTag,
      },
    );

  return mapServerAgentExecutionToAgentExecution(response);
};
